<template>
  <div
    class="filters"
    :class="{'is-show': isShowFilters}"
  >
    <b-card class="bg mb-3">
      <b-form @submit="submitSearch" size="sm">
        <b-form-row>
          <b-col>
            <b-form-group label-size="sm" :label="nameLabel+':'">
              <b-form-input :placeholder="nameLabel+'...'" v-model="searchQuery.query"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col v-if="statuses.length > 0">
            <b-form-group label="Статус" label-size="sm">
              <b-input-group>
                <b-form-select
                  v-model="searchQuery.status"
                  :options="statuses"
                  value-field="name"
                  text-field="title"
                ></b-form-select>
                <b-input-group-append v-if="searchQuery.status">
                  <b-button @click="searchQuery.status = null">
                    Очистить
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-form-group label-size="sm" label="Теги:">
              <tags v-bind:value="searchQuery.tags" v-on:input="searchQuery.tags = $event" placeholder="Введите название для поиска"></tags>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-size="sm" label="Дата создания от:">
              <b-input v-model="searchQuery.created_from" type="date"/>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-size="sm" label="Дата создания до:">
              <b-input v-model="searchQuery.created_to" type="date"/>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-size="sm" label="Дата оплаты от:">
              <b-input v-model="searchQuery.paymentAtFrom" type="date"/>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-size="sm" label="Дата оплаты до:">
              <b-input v-model="searchQuery.paymentAtTo" type="date"/>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="5">
            <b-button type="submit" variant="primary" size="sm" class="mr-2">Найти</b-button>
            <b-button type="button" @click="resetSearch" size="sm">Сбросить</b-button>
          </b-col>
          <b-col cols="7">
            <b-alert class="p-2" v-model="errorResult" dismissible variant="danger">{{ messageResult }}</b-alert>
          </b-col>
        </b-form-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Tags from "./tags"

export default {
  name: 'search-form',
  components: {Tags},
  props: {
    statuses: {
      type: Array,
      default:()=> [],
    },
    errorResult: {},
    messageResult: {},
    searchQuery: {},
    submitSearch: {},
    resetSearch: {},
    nameLabel: {
      type: String,
      default: 'Название'
    },
    isShowFilters: {
      type: Boolean,
      default: false,
    },
  }
}
</script>

<style lang="sass">
.multiselect__tags
  border-color: #ced4da
</style>

<style scoped lang="sass">
.filters
  position: relative
  overflow: hidden
  height: 0
  transition: height .3s

  &.is-show
    height: 260px

.bg
  background: #f5f5f5
</style>
